/**
 * Whether a job ad brings its own look: a stylesheet, a table layout, a
 * background or chosen text colours. Those were designed for a white page and
 * are shown framed, as authored (`HtmlDocumentFrame`).
 *
 * The rest are plain text with basic markup — paragraphs, headings, lists,
 * bold — and at most font, size or alignment tweaks from an editor. Framed,
 * they would be unstyled serif text on white, so they render in the app's own
 * typography instead (`RichText`, which also drops those inline tweaks).
 */
const DESIGNED_MARKERS = [
  /<style[\s>]/i,
  /<link[\s>]/i,
  /<table[\s>]/i,
  /\bbgcolor\s*=/i,
  /\bbackground(?:-[a-z]+)?\s*:/i,
  /\bbackground\s*=/i,
  // `color:` as its own declaration, not the tail of `background-color:`.
  /(?:^|[\s;"'{])color\s*:/i,
  /<font\b[^>]*\bcolor\s*=/i,
];

export function isDesignedJobHtml(html: string): boolean {
  return DESIGNED_MARKERS.some((marker) => marker.test(html));
}
